import React from 'react';
import * as Styled from '../../Sizes.styles';
export default (function () {
  return /*#__PURE__*/React.createElement(Styled.ResponsiveWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\xA0"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Dual Size"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Total Height"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Chest"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Waist"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Hip"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "Inside Leg"))), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "5lb"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "5lb"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "44cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "37cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "37cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "37cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "14cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "7lb"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "7lb"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "50cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "17cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "1 month"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "0-1 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "56cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "39cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "20cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "3 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "1-3 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "62cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "43cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "43cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "42.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "22.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "6 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "3-6 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "68cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "46cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "45cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "46cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "25.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "9 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "6-9 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "74cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "47cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "46.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "48cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "29cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "12 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "9-12 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "80cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "50cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "48.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "50cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "18 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "12-18 months"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "86cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "51cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "50cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "51.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "35cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "2 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "18months - 2 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "92cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "52.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "50.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "53cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "3 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "2-3 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "98cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "54.25cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "52.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "56cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "42.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "4 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "3-4 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "104cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "56cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "54.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "60cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "45.5cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "5 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "4-5 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "110cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "58cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "55cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "62cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "50cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "6 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "5-6 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "116cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "60.5cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "56cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "64cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "52cm")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "7 years"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "6-7 yrs"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "122cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "63cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "57cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "66cm"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "56cm")))));
});